import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Badge,
  ButtonGroup,
  ToggleButton,
  Spinner,
} from "react-bootstrap";
import LoginImg from "../../assets/images/vfr.jpg";
import { useNavigate } from "react-router-dom";
import WebService from "../../Services/WebService";
import { toast } from "react-toastify";
import { HandbagFill } from "react-bootstrap-icons";
import SubscriptionCancel from "../../components/SubscriptionCancel/SubscriptionCancel";
import "./MySubscription.scss";
import SubscriptionPlans from "../../components/SubscriptionPlans/SubscriptionPlans";
const Profile = () => {
  const [subscriptions, setSubscriptions] = useState<any[]>([]);
  const [activeTab, setActiveTab] = useState("vfr");
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [request, setRequest] = useState<any>("");

  const navigate = useNavigate();

  useEffect(() => {
    subscriptionList();
  }, []);

  const subscriptionList = () => {
    setLoading(true);
    WebService.postAPI({
      action: `/users/subscribed-plans`,
      body: null,
    })
      .then((res: any) => {
        setSubscriptions(res.list || []);
        setLoading(false);
      })
      .catch((e: any) => {
        setLoading(false);
        toast.error(e?.response?.data?.message || "Failed to load plans");
      });
  };
  const HandelCancel = (uuid: string) => {
    setShowModal(true);
    setRequest(uuid);
  };
  const cancelPlan = async (uuid: string) => {
    try {
      const res: any = await WebService.postAPI({
        action: `/cancel_subscription_payment`,
        body: { subscription_uuid: uuid },
      });

      if (res.success) {
        toast.success("Your plan has been cancelled successfully.");
        subscriptionList(); // Refresh list
      } else {
        toast.error(res.message || "Failed to cancel subscription.");
      }
    } catch (err: any) {
      toast.error(err?.response?.data?.message || "Error cancelling plan");
    }
  };

  const checkStatus = (item: any) => {
    const today = new Date();
    const endDate = new Date(item.end_date);

    if (item.is_cancelled === "Y") return "Cancelled";
    if (endDate < today) return "Expired";    
    return "Active";
  };

  // 🔹 Filter by VFR / IFR
  const filteredSubscriptions = subscriptions.filter((item) =>
    activeTab === "vfr"
      ? item.subscription_plan?.is_vfr === 1
      : item.subscription_plan?.is_ifr === 1
  );

  if (loading) {
    return (
      <Container className="text-center py-5">
        <Spinner animation="border" variant="info" />
        <p className="mt-2 text-muted">Loading subscriptions...</p>
      </Container>
    );
  }

  if (!subscriptions || subscriptions.length === 0) {
    return (
      <Container className="py-5">
        <div className="text-center mb-4">
          {/* <h5 className="fw-bold">No Active Subscriptions</h5>
        <p className="text-muted">
          You don’t have any active plans right now. Choose one below to get started.
        </p> */}
        </div>
        {/* 👇 This renders the full subscription plan UI from the second component */}
        <SubscriptionPlans />
      </Container>
    );
  }

  return (
    <Container className="py-5">
      {/* Title + Tabs */}
      <div className="text-center mb-4">
        <h5 className="fw-bold">My Subscriptions</h5>
        <p className="text-muted">
          Manage and view your VFR and IFR subscription plans.
        </p>

        <ButtonGroup>
          <ToggleButton
            id="vfr-tab"
            type="radio"
            variant={activeTab === "vfr" ? "info" : "outline-secondary"}
            name="tabs"
            value="vfr"
            checked={activeTab === "vfr"}
            onClick={() => setActiveTab("vfr")}
            style={{
              backgroundColor: activeTab === "vfr" ? "#00A899" : "",
              color: activeTab === "vfr" ? "white" : "",
              border: "1px solid #ccc",
            }}
          >
            VFR
          </ToggleButton>
          <ToggleButton
            id="ifr-tab"
            type="radio"
            variant={activeTab === "ifr" ? "info" : "outline-secondary"}
            name="tabs"
            value="ifr"
            checked={activeTab === "ifr"}
            onClick={() => setActiveTab("ifr")}
            style={{
              backgroundColor: activeTab === "ifr" ? "#00A899" : "",
              color: activeTab === "ifr" ? "white" : "",
              border: "1px solid #ccc",
            }}
          >
            IFR
          </ToggleButton>
        </ButtonGroup>
      </div>

      {/* Cards */}
      {filteredSubscriptions.length > 0 ? (
        <Row className="g-4 justify-content-center">
          {filteredSubscriptions.map((item) => {
            const plan = item.subscription_plan;
            const status = checkStatus(item);
            const statusColor =
              status === "Cancelled"
                ? "#e74c3c"
                : status === "Expired"
                ? "#f39c12"
                : "#00A693";

            return (
              <Col key={item.uuid} xs={12} md={6} lg={4}>
                <Card
                  className="shadow-sm h-100 position-relative"
                  style={{ background: "#f8f9fb" }}
                >
                  <Card.Body className="bg-white rounded-4 p-4 d-flex flex-column justify-content-between">
                    {/* Top Row: Badge + Price */}
                    <Row className="align-items-start">
                      <Col xs={6}>
                        <Badge
                          bg={
                            status === "Active"
                              ? "warning"
                              : status === "Cancelled"
                              ? "danger"
                              : status === "Expired"
                              ? "secondary"
                              : "light"
                          }
                          text="white"
                          className="mb-2 px-3 py-2 rounded-pill"
                        >
                          {status === "Active" ? "Current Plan" : status}
                        </Badge>
                      </Col>

                      <Col
                        xs={6}
                        className="text-end fw-bold"
                        style={{ color: "#00A693", fontSize: "1.4rem" }}
                      >
                        {item?.price_with_currency}
                      </Col>
                    </Row>

                    {item.is_cancelled === "Y" && item.cancelled_datetime && (
                      <div
                        className="alert alert-secondary mt-3 mb-0 py-2 px-3 small text-center"
                        style={{
                          borderRadius: "8px",
                          backgroundColor: "#f1f1f1",
                        }}
                      >
                        <strong>Cancelled on:</strong>{" "}
                        {new Date(item.cancelled_datetime).toLocaleDateString(
                          "en-GB",
                          {
                            day: "2-digit",
                            month: "long",
                            year: "numeric",
                          }
                        )}
                      </div>
                    )}

                    {/* Product Row */}
                    <Row className="align-items-center mt-2">
                      <Col xs={3}>
                        <img
                          src={LoginImg}
                          alt={plan?.name}
                          style={{ height: "75px" }}
                        />
                      </Col>
                      <Col xs={9}>
                        <h5 className="fw-bold mb-1">{plan?.name}</h5>
                        <div>
                          <span
                            className="fw-bold"
                            style={{ color: "#00A693", fontSize: "1.1rem" }}
                          >
                            {item?.price_with_currency || "€0"}
                          </span>
                          <small className="text-muted mb-1">
                            {" "}
                            {"/"}{plan?.duration_format}, billed annually
                          </small>
                        </div>
                        <small className="text-muted">
                          (Excluding Professional Services)
                        </small>
                      </Col>
                    </Row>

                    {/* Description */}
                    <p className="mt-3">{plan?.description}</p>

                    {/* Expiry Date */}
                    <div className="mb-3">
                      <span className="text-muted">Expiry Date </span>
                      <span className="fw-bold" style={{ color: statusColor }}>
                        {new Date(item.end_date).toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "long",
                          year: "numeric",
                        })}
                      </span>
                    </div>

                    {/* Cancelled message */}
                    {item.is_cancelled === "Y" && item.cancelled_datetime && (
                      <div className="alert alert-secondary mt-2 mb-0 py-2 px-3 small">
                        Your plan was cancelled on{" "}
                        <strong>
                          {new Date(item.cancelled_datetime).toLocaleDateString(
                            "en-GB",
                            {
                              day: "2-digit",
                              month: "long",
                              year: "numeric",
                            }
                          )}
                        </strong>
                        .
                      </div>
                    )}
                    {/* Cancel Button */}
                    {item.is_cancelled === "N" && status === "Active" && (
                      <div className="d-flex justify-content-end mt-2">
                        <Button
                          variant="danger"
                          size="sm"
                          className="cancel-plan-btn text-white fw-semibold"
                          style={{
                            backgroundColor: "#dc3545", // Bootstrap danger red
                            border: "none",
                            padding: "6px 14px",
                            borderRadius: "6px",
                          }}
                          onClick={() => HandelCancel(item.uuid)}
                        >
                          Cancel Plan
                        </Button>
                      </div>
                    )}

                    <hr />

                    {/* Buttons */}
                    <Button
                      variant="success"
                      className="w-100 py-2 rounded-3 fw-bold"
                      disabled={status === "Active"}
                      style={{
                        backgroundColor:
                          status === "Active" ? "#00A693" : "#00A693",
                        opacity: status === "Active" ? 0.6 : 1,
                        border: "none",
                        cursor: status === "Active" ? "not-allowed" : "pointer",
                      }}
                      onClick={() => {
                        if (status === "Active") return;
                        if (status === "Cancelled" || status === "Expired") {
                          navigate("/buy", {
                            state: { plan: item.subscription_plan },
                          });
                        } else {
                          navigate("/subscriptionplans");
                        }
                      }}
                    >
                      {status === "Active"
                        ? "CURRENT PLAN"
                        : "BUY / RENEW PLAN"}
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            );
          })}
        </Row>
      ) : (
        <p className="text-center text-muted">
          No subscriptions found for {activeTab.toUpperCase()}.
        </p>
      )}
      {showModal && (
        <SubscriptionCancel
          uuid={request}
          title="Are you sure you want to cancel subscription!"
          showModal={showModal}
          onCloseModel={() => {
            setShowModal(false);
            subscriptionList();
          }}
        />
      )}
    </Container>
  );
};

export default Profile;
